import type { MangoApiClient } from '@mangovoice/mango-api-client'

import type {
  PaginatedApiResult,
  UserGroupListParams,
} from '../types/api.types'
import type {
  UserGroup,
  UserGroupCreate,
  UserGroupUpdate,
} from '../types/userGroup.types'
import { USER_GROUP_ENDPOINTS } from './endpoints'

export type UserGroupApiClient = MangoApiClient['userGroups']

export interface PbxUserItem {
  id: number
  user: {
    id: number
    first_name: string
    last_name: string
    name: string
    email: string
    username: string
  }
}

/**
 * Create user group API functions from a client
 */
export const createUserGroupApi = (client: UserGroupApiClient) => ({
  getUserGroups: (pbxId: number, params?: UserGroupListParams) =>
    client.get<PaginatedApiResult<UserGroup>>(
      USER_GROUP_ENDPOINTS.LIST(pbxId),
      params as Record<string, unknown>,
    ),

  getUserGroup: (pbxId: number, id: number) =>
    client.get<UserGroup>(USER_GROUP_ENDPOINTS.DETAIL(pbxId, id)),

  createUserGroup: (pbxId: number, data: UserGroupCreate) =>
    client.post<UserGroup>(USER_GROUP_ENDPOINTS.CREATE(pbxId), data),

  updateUserGroup: (pbxId: number, id: number, data: UserGroupUpdate) =>
    client.patch<UserGroup>(USER_GROUP_ENDPOINTS.UPDATE(pbxId, id), data),

  deleteUserGroup: (pbxId: number, id: number) =>
    client.delete<void>(USER_GROUP_ENDPOINTS.DELETE(pbxId, id)),

  getPbxUsers: (pbxId: number) =>
    client.get<PaginatedApiResult<PbxUserItem>>(
      USER_GROUP_ENDPOINTS.PBX_USERS(pbxId),
      { limit: 1000 },
    ),
})

export type UserGroupApi = ReturnType<typeof createUserGroupApi>
